




























import { Component, Prop, Vue } from 'vue-property-decorator'

import { Invoice, InvoiceStatus, PaymentMethodEnum } from '@/models'

import { VuesaxColors } from '@/shims-vuesax'

type PaymentMethodChipColors = VuesaxColors | '#2E53B4' | '#9C26D4'

@Component
export default class InvoicePaymentMethodChip extends Vue {
  @Prop({ type: Object, required: true })
  readonly invoice!: Invoice

  PaymentMethodColors: { [key in PaymentMethodEnum]: PaymentMethodChipColors } = {
    [PaymentMethodEnum.CASH]: 'success',
    [PaymentMethodEnum.CREDIT_CARD]: 'primary',
    [PaymentMethodEnum.DEBIT_CARD]: '#2E53B4',
    [PaymentMethodEnum.ONLINE]: '#9C26D4'
  }

  PaymentMethodTexts: { [key in PaymentMethodEnum]: string } = {
    [PaymentMethodEnum.CASH]: 'Dinheiro',
    [PaymentMethodEnum.CREDIT_CARD]: 'Cartão de crédito',
    [PaymentMethodEnum.DEBIT_CARD]: 'Cartão de débito',
    [PaymentMethodEnum.ONLINE]: 'Online'
  }

  get isClosed () {
    return this.invoice.status === InvoiceStatus.CLOSED
  }

  get statusColor (): PaymentMethodChipColors {
    if (this.invoice.paymentMethod) {
      return this.PaymentMethodColors[this.invoice.paymentMethod]
    }

    return 'dark'
  }

  get statusText () {
    if (this.invoice.paymentMethod) {
      return this.PaymentMethodTexts[this.invoice.paymentMethod]
    }

    return this.isClosed
      ? 'Confirmado'
      : 'Em aberto'
  }
}
